import type { SflColors } from './useSflColors';
import { mvs } from './tokens';

/** Inline-friendly text presets for web (mirrors createSflTextStyles intent) */
export function createSflTextStyles(colors: SflColors) {
  return {
    body: {
      fontSize: mvs(14),
      lineHeight: 1.45,
      color: colors.text,
      fontFamily: 'var(--sfl-font-sans)',
    } as const,
    title: {
      fontSize: mvs(15),
      lineHeight: 1.35,
      fontWeight: 500 as const,
      letterSpacing: '-0.01em',
      color: colors.text,
      fontFamily: 'var(--sfl-font-sans)',
    } as const,
    label: {
      fontSize: mvs(11),
      lineHeight: 1.2,
      fontWeight: 600 as const,
      textTransform: 'uppercase' as const,
      letterSpacing: '0.06em',
      color: colors.text3,
      fontFamily: 'var(--sfl-font-sans)',
    } as const,
    brandItalic: {
      fontFamily: 'var(--sfl-font-brand)',
      fontStyle: 'italic' as const,
      color: colors.text,
    } as const,
    marketingHeadline: {
      fontSize: mvs(24),
      lineHeight: 1.25,
      fontWeight: 600 as const,
      color: colors.text,
      fontFamily: 'var(--sfl-font-sans)',
    } as const,
  };
}
